<template>
  <!-- 上游工号管理 -->
  <div class="content main-container">
    <div class="wrapper">
      <div class="search-box btn3" :class="{ close: !searchMore }">
        <div class="input-item">
          <span class="label">姓名/工号</span>
          <Input v-model="searchParams.nameOrStaffNo" placeholder="请输入姓名/工号" clearable />
        </div>
        <div class="input-item">
          <span class="label">机构/团队</span>
          <selectTree type="2" v-model="searchParams.orgId" @change="selectTreeChange"></selectTree>
        </div>
        <div class="input-item">
          <span class="label">人员状态</span>
          <Select v-model="searchParams.workingState" clearable transfer>
            <Option value="1" label="在职" />
            <Option value="0" label="离职" />
          </Select>
        </div>
        <div class="input-item">
          <span class="label">手机号</span>
          <Input v-model="searchParams.mobile" placeholder="请输入手机号" clearable />
        </div>
        <div class="input-item">
          <span class="label">身份证号</span>
          <Input v-model="searchParams.idNo" placeholder="请输入身份证号" clearable />
        </div>
        <div class="input-item">
          <span class="label">上号保司</span>
          <Input v-model="searchParams.companyName" placeholder="请输入上号保司" clearable />
          <!-- <Select v-model="searchParams.companyStaffNo" size="small">
            <Option v-for="item in insurerList" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select> -->
        </div>
        <div class="input-item">
          <span class="label">保司工号</span>
          <Input v-model="searchParams.companyStaffNo" placeholder="请输入保司工号" clearable />
        </div>
        <div class="btn-item">
          <Button type="primary" @click="searchAjax()">查询</Button>
          <Button type="primary" ghost @click="handleReset">重置</Button>
          <Button type="primary" ghost v-if="searchMore" @click="searchMore = false">收起<Icon type="ios-arrow-up"/></Button>
          <Button type="primary" ghost v-else @click="searchMore = true">展开<Icon type="ios-arrow-down"/></Button>
        </div>
      </div>
      <div class="tabBox">
        <Tabs v-model="searchParams._status" :animated="false" @on-click="handleOnClickTab" class="tabs-box">
          <TabPane label="全部" name="all" />
          <TabPane label="待处理" name="0,2" />
          <TabPane label="已上号" name="1" />
          <TabPane label="上号失败" name="-1" />
          <TabPane label="已注销" name="3" />
          <template #extra>
            <!-- <Button v-if="$units.pointAction('org_200_3')" type="warning" @click="removalAll()">批量导入</Button> -->
            <Button v-if="$units.pointAction('org_200_3')" type="warning" @click="exportExcel()" ghost>导出</Button>
          </template>
        </Tabs>
        <!-- 待处理时可见 -->
        <Tabs @on-click="toggleTabSecond" v-model="searchParams._subStatus" v-if="searchParams._status == '0,2'" class="second-tabs" :animated="false">
          <TabPane label="开通中" name="0"></TabPane>
          <TabPane label="注销中" name="2"></TabPane>
        </Tabs>
      </div>
      <div class="table-box">
        <loading :isShow="listLoading" />
        <Table :columns="columns" :data="tableData">
          <!-- 姓名 -->
          <template slot-scope="{ row }" slot="name">
            <div style="display: flex; align-items: center; white-space: nowrap; justify-content: center">
              <i class="dian" :class="{ 'red': row.workingState == 0, 'orange': row.isSus == 1 }"></i>
              <span class="user-name">{{ row.name }}/{{ row.staffNo }}</span>
            </div>
          </template>
          <!-- 手机号 -->
          <template slot-scope="{ row }" slot="mobile">
            <div style="display: flex; align-items: center; white-space: nowrap; justify-content: center">
              <span v-if="row.eyeShow">{{ row.mobile1 }}</span>
              <span v-else>{{ row.mobile }}</span>
              <div v-if="row.mobile">
                <i class="iconfont iconxianshi eye-icon eye" v-if="row.eyeShow" @click="openEye(row, 'mobile1', 2, 'eyeShow')"></i>
                <i class="iconfont iconyincang eye-icon eye" v-else @click="openEye(row, 'mobile1', 2, 'eyeShow')"></i>
              </div>
            </div>
          </template>
          <!-- 证件号 -->
          <template slot-scope="{ row }" slot="idNo">
            <div style="display: flex; align-items: center; white-space: nowrap; justify-content: center">
              <span v-if="row.eyeShow1">{{ row.idNo1 }}</span>
              <span v-else>{{ row.idNo }}</span>
              <div v-if="row.idNo">
                <i class="iconfont iconxianshi eye-icon eye" v-if="row.eyeShow1" @click="openEye(row, 'idNo1', 1, 'eyeShow1')"></i>
                <i class="iconfont iconyincang eye-icon eye" v-else @click="openEye(row, 'idNo1', 1, 'eyeShow1')"></i>
              </div>
            </div>
          </template>
          <template slot-scope="{ row }" slot="action">
            <div class="detail">
              <div v-if="$units.pointAction('org_200_1')" @click="viewDetail(row)">详情</div>
              <!-- 注销中 -->
              <div v-if="$units.pointAction('org_200_5') && [2].includes(row.status * 1)" @click="removal(row)">注销</div>
              <!-- 申请中，上号失败，人工上号的保司 -->
              <div
                v-if="searchParams._status != '-1' && $units.pointAction('org_200_7') && [0, -1].includes(row.status * 1) && row.signUpMethod == 1"
                @click="openWkModal(row, '1')"
              >
                人工上号
              </div>
              <!-- 申请中，上号失败，接口上号的保司 -->
              <div
                v-if="searchParams._status != '-1' && $units.pointAction('org_200_6') && [0, -1].includes(row.status * 1) && row.signUpMethod == 2"
                @click="openWkModal(row, '2')"
              >
                一键上号
              </div>
            </div>
          </template>
        </Table>
        <div class="pageBox">
          <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" />
        </div>
      </div>
      <import-tool ref="importTool" @success="searchAjax()"></import-tool>
    </div>

    <!-- 上号  -->
    <Modal v-model="upWkModalVisible" :title="upWkModalTitle" width="500" :footer-hide="true" :mask-closable="false">
      <Form :model="upWkModalForm" ref="upWkModalFormRef" :label-width="120">
        <FormItem label="上号结果" prop="status" :rules="$units.formRule.required('请选择')">
          <RadioGroup v-model="upWkModalForm.status">
            <Radio label="1">成功</Radio>
            <Radio label="-1">失败</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem v-if="upWkModalForm.status == '1'" label="上游保司账号" prop="companyStaffNo" :rules="$units.formRule.required('请输入')">
          <Input v-model="upWkModalForm.companyStaffNo" placeholder="请输入" />
        </FormItem>
        <FormItem v-if="upWkModalForm.status == '1'" label="有效期" prop="date" :rules="$units.formRule.arrRequired('请输入')">
          <DatePicker
            style="width: 100%;"
            type="daterange"
            split-panels
            separator="至"
            :transfer="true"
            placement="bottom"
            format="yyyy-MM-dd"
            placeholder="选择日期"
            :value="upWkModalForm.date"
            @on-change="$set(upWkModalForm, 'date', $event && $event[0] ? $event : [])"
          ></DatePicker>
        </FormItem>
        <FormItem v-if="upWkModalForm.status == '-1'" label="失败原因" prop="remark" :rules="$units.formRule.required('请输入')">
          <Input v-model="upWkModalForm.remark" type="textarea" showWordLimit maxlength="20" placeholder="请输入" />
        </FormItem>
        <div class="ivu-modal-footer">
          <Button type="text" @click="upWkModalVisible = false">取消</Button>
          <Button type="primary" @click="onConfirmWk">确定</Button>
        </div>
      </Form>
    </Modal>

    <DetailModal ref="detailModal" />
  </div>
</template>
<script>
import { pageTool, common } from '@/api/mixins';
import selectTree from '@/components/system/selectTree3';
import topSearchForm from '@/components/commons/topSearchForm';
import importTool from '@/components/commons/importTool/index2';
import DetailModal from './detailModal.vue';
import { Modal } from 'view-design';

const dic = JSON.parse(localStorage.dic);
const AGENT_SIGN_STATUS = dic['AGENT_SIGN_STATUS'];

export default {
  mixins: [pageTool, common],
  components: {
    selectTree,
    topSearchForm,
    importTool,
    DetailModal
  },
  data() {
    return {
      AGENT_SIGN_STATUS: Object.freeze(AGENT_SIGN_STATUS),
      upWkModalVisible: false,
      upWkModalTitle: '',
      upWkModalForm: {
        status: '1',
        companyStaffNo: '',
        date: [],
        remark: ''
      },
      insurerList: [],
      searchParams: {
        nameOrStaffNo: '',
        orgId: '',
        groupId: '',
        workingState: '',
        mobile: '',
        companyStaffNo: '',
        companyName: '',
        _status: 'all',
        _subStatus: '0'
      },
      tableData: [],
      columns: []
    };
  },
  mounted() {
    this.getColumns();
    this.initListAjax('/buz/okbao/agent/pageList');
  },
  methods: {
    handleOnClickTab(name) {
      this.getColumns();
      this.searchAjax();
    },
    getColumns() {
      let columns = [
        {
          title: '更新时间',
          key: 'createTime',
          align: 'center',
          width: 160
        },
        // {
        //   title: '工号',
        //   key: 'staffNo',
        //   align: 'center',
        //   width: 160
        // },
        {
          title: '姓名/工号',
          slot: 'name',
          align: 'center',
          width: 320
        },
        {
          title: '手机号',
          slot: 'mobile',
          align: 'center',
          width: 140
        },
        {
          title: '证件号',
          slot: 'idNo',
          align: 'center',
          minWidth: 180
        },
        {
          title: '上号保司',
          key: 'company',
          align: 'center',
          minWidth: 180
        },
        {
          title: '状态',
          key: 'status',
          align: 'center',
          width: 100,
          render(h, params) {
            return <span>{AGENT_SIGN_STATUS[params.row.status]}</span>;
          }
        },
        {
          title: '上游保司工号',
          key: 'companyStaffNo',
          align: 'center',
          minWidth: 180,
          render(h, params) {
            return <span>{params.row.companyStaffNo || '-'}</span>;
          }
        },
        {
          title: '有效期',
          key: 'licenceDate',
          align: 'center',
          minWidth: 180,
          render: (h, params) => {
            const start = this.$units.formatDate(params.row.licenceStartDate, 'yyyy-MM-dd');
            const end = this.$units.formatDate(params.row.licenceEndDate, 'yyyy-MM-dd');
            if (start && end) {
              return (
                <span>
                  {start}至{end}
                </span>
              );
            } else {
              return <span>-</span>;
            }
          }
        }
      ];
      if (['all', '-1'].includes(this.searchParams._status)) {
        columns.push({
          title: '备注',
          key: 'remark',
          align: 'center',
          minWidth: 180,
          render(h, params) {
            if (params.row.remark) {
              return h(
                'Tooltip',
                {
                  class: 'flex-center',
                  props: { placement: 'bottom-start', transfer: true }
                },
                [
                  h(
                    'span',
                    {
                      style: 'display: inline-block;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;width: 11em'
                    },
                    params.row.remark
                  ),
                  h('span', { slot: 'content' }, params.row.remark)
                ]
              );
            } else {
              return h('span', { slot: 'content' }, '-');
            }
          }
        });
      }
      columns = columns.concat([
        {
          title: '所属机构',
          key: 'orgName',
          align: 'center',
          minWidth: 180
        },
        {
          title: '所属团队',
          key: 'groupName',
          align: 'center',
          minWidth: 180
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: '140',
          fixed: 'right'
        }
      ]);
      this.columns = columns;
    },
    // 解密
    openEye(row, name, i, eyeShow) {
      let val = {
        query: row.id,
        operationFunction: 62,
        operationType: i
      };
      if (!row[eyeShow]) {
        this.descrypt(val, row, name).then(() => {
          this.$set(row, eyeShow, true);
        });
      } else {
        this.$set(row, eyeShow, false);
      }
    },
    // 分页
    pageChange(pageNo) {
      this.searchParams.pageNo = pageNo;
      this.getList();
    },
    viewDetail(row) {
      this.$refs.detailModal.open(row);
    },
    openWkModal(row, t) {
      this.currRowData = row;
      this.upWkModalTitle = t == '1' ? '人工上号' : '一键上号';
      this.upWkModalForm = {
        status: '1',
        companyStaffNo: '',
        date: [],
        remark: ''
      };
      if (t === '2') {
        Modal.confirm({
          title: '提示',
          content: '是否确认一键上号？',
          okText: '确认',
          cancelText: '取消',
          onOk: () => {
            console.log('一键上号');
            this.$http({
              type: 'POST',
              url: '/buz/okbao/agent/signUp',
              data: {
                id: this.currRowData.id,
                status: '1'
              }
            })
              .then(() => {
                this.$Message.success('操作成功');
                this.getList();
              })
              .catch(err => {
                console.error(err);
              });
          }
        });
        return;
      }
      this.upWkModalVisible = true;
      this.$refs.upWkModalFormRef.resetFields();
    },
    onConfirmWk() {
      this.$refs.upWkModalFormRef.validate(valid => {
        if (valid) {
          const data = {
            id: this.currRowData.id,
            status: this.upWkModalForm.status
          };
          if (data.status == '1') {
            data.companyStaffNo = this.upWkModalForm.companyStaffNo;
            const date = this.upWkModalForm.date;
            if (date && date[0]) {
              data.licenceStartDate = date[0];
              data.licenceEndDate = date[1];
            }
          }

          if (data.status == '-1') {
            data.remark = this.upWkModalForm.remark;
          }

          this.$http({
            type: 'POST',
            url: '/buz/okbao/agent/signUp',
            data
          })
            .then(() => {
              this.$Message.success('操作成功');
              this.upWkModalVisible = false;
              this.listLoading = true;
              this.getList();
            })
            .catch(err => {
              console.error(err);
            });
        }
      });
    },
    setListParams(params) {
      if (params._status == 'all') {
        params.statusList = '';
      } else if (params._status == '0,2') {
        params.statusList = [params._subStatus];
      } else {
        params.statusList = [params._status];
      }
      delete params._subStatus;
      delete params._status;
    },
    handleReset() {
      this.resetSearch();
      this.searchParams._status = 'all';
      this.searchParams._subStatus = '0';
    },
    // 导出
    exportExcel() {
      this.listLoading = true;
      let data = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(data);
      delete data.pageNo;
      delete data.pageSize;
      this.$http({
        url: '/buz/okbao/agent/export',
        type: 'POST',
        responseType: 'blob',
        data,
        apiPermissionCode: 'org_200_3'
      })
        .then(res => {
          this.listLoading = false;
          this.$units.daochu(res);
        })
        .catch(e => {
          this.listLoading = false;
        });
    },
    toggleTabSecond() {
      this.pageNo = 1;
      this.getList();
    },
    selectTreeChange(item) {
      this.searchParams.organizationId = '';
      this.searchParams.groupId = '';
      if (item.nodeType == 1) {
        this.searchParams.organizationId = item.id;
      } else if (item.nodeType == 2) {
        this.searchParams.groupId = item.id;
      }
    },
    // 注销
    removal(row) {
      this.$Modal.confirm({
        title: '注销',
        content: '注销成功后，该代理人将无法销售下号保司的经代产品，是否继续？',
        onOk: () => {
          this.$http({
            url: '/buz/okbao/agent/logout',
            type: 'POST',
            data: {
              id: row.id
            }
          }).then(res => {
            this.$Message.success('操作成功');
            this.listLoading = true;
            this.getList();
          });
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/.ivu-btn-ghost.ivu-btn-warning {
  background-color: transparent;
}
/deep/.search-box {
  margin-bottom: 15px;
}

/deep/ .ivu-modal-content {
  overflow: hidden;
}
.content {
  .titleBox {
    background: #fff;
    border-bottom: 10px solid #f5f7f9;
    padding: 17px 26px;
    position: relative;

    .right {
      position: absolute;
      font-size: 14px;
      color: #727c8e;
      right: 25px;
      top: 50%;
      transform: translateY(-50%);

      &:hover {
        cursor: pointer;
      }

      span {
        margin-right: 6px;
      }
    }

    h1 {
      font-size: 24px;
      color: #3c464f;
      position: relative;
      padding-left: 10px;
      font-weight: bold;

      &:before {
        content: '';
        left: 0;
        top: 50%;
        margin-top: -10px;
        width: 4px;
        height: 20px;
        background: #236dff;
        opacity: 1;
        border-radius: 3px;
        position: absolute;
      }
    }

    p {
      font-size: 14px;
      color: #a8adb7;
      margin-top: 10px;
    }
  }
  .tabBox {
    margin-top: -10px;
    .tabs-box {
      /deep/ {
        .ivu-tabs-bar {
          border-bottom: 1px solid #ececec;
        }
        .ivu-tabs-ink-bar {
          display: none;
        }
        .ivu-tabs-tab {
          padding: 9px 0 10px;
          margin-right: 44px;
          font-size: 14px;
          color: #515c6f;
        }
        .ivu-tabs-tab-active {
          position: relative;
          color: #236dff;
          &::before {
            content: '';
            position: absolute;
            left: 0;
            bottom: 1px;
            height: 2px;
            width: 100%;
            background-color: #236dff;
          }
        }
      }
    }
  }
}
</style>
